import axios from "axios";
import { api_host } from "./settings";

interface PaymentConfig {
  payment_required: boolean;
  stripe_publishable_key: string;
}

interface CheckoutSessionResponse {
  session_url: string;
}

interface PaymentStatusResponse {
  status: string;
  order_id: string;
}

export async function getPaymentConfig(): Promise<PaymentConfig> {
  const response = await axios.get(`${api_host}/api/payment/config/`);
  return response.data;
}

export async function createCheckoutSession(orderId: string): Promise<CheckoutSessionResponse> {
  const response = await axios.post(`${api_host}/api/payment/create-checkout-session/`, {
    order_id: orderId,
  });
  return response.data;
}

export async function getPaymentStatus(sessionId: string): Promise<PaymentStatusResponse> {
  const response = await axios.get(`${api_host}/api/payment/status/${sessionId}/`);
  return response.data;
}

